export default __webpack_public_path__ + "static/media/kaminfeuer_web-md@1x.90758486.webp";